
export type Comparator<T> = (a: T, b: T) => number;

export function concatComparators<T>(...comparators: Comparator<T>[]): Comparator<T> {
  return (a: T, b: T) => {
    for(const comparator of comparators) {
      const result = comparator(a, b);

      if(result !== 0) {
        return result;
      }
    }

    return 0;
  };
}

export type NullableComparatorOrdering = 'NullsFirst' | 'NullsLast';

export function toNullableComparator<T>(
  comparator: Comparator<T>,
  ordering?: NullableComparatorOrdering,
): Comparator<T | null | undefined> {
  ordering ??= 'NullsLast';
  const nullOrder = ordering === 'NullsFirst' ? -1 : 1;

  return (a: T | null | undefined, b: T | null | undefined) => {
    switch(true) {
    case a == null && b == null:
      return 0;
    case a == null:
      return nullOrder;
    case b == null:
      return -nullOrder;
    default:
      return comparator(a, b);
    }
  };
}

export function mapComparator<TValue, TComparator>(
  mapper: (value: TValue) => TComparator,
  comparator: Comparator<TComparator>,
): Comparator<TValue> {
  return (a: TValue, b: TValue) => {
    return comparator(mapper(a), mapper(b));
  }
}
